export const advisoryProductGroups = [
  { value: "security", label: "Cenný papír" },
  { value: "portfolio-strategy", label: "Portfolio strategie" },
  { value: "dps", label: "Doplňkové penzijní spoření" },
  { value: "transformed-fund", label: "Transformované fondy" },
  { value: "building-savings", label: "Stavební spoření" },
  { value: "cash-account", label: "Hotovostní účet" },
];
